/* ============================================================
   03 · MAIN PRODUCT — comportamiento
   La compra funciona SIN este archivo: los selectores de oferta
   son radios con name="id" dentro del formulario nativo de
   Shopify. Esto solo añade la galería y el total en vivo.

   La galería usa el mismo tratamiento que los demás carruseles:
   el imán de scroll-snap se aparta mientras el código mueve la
   tira, y los puntos solo se repintan cuando cambia la foto.
   ============================================================ */
(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var scope = root || document;

    /* ---------- Galería ---------- */
    scope.querySelectorAll('[data-ba-gallery]').forEach(function (gal) {
      if (gal.__ba) return;
      gal.__ba = true;

      var track = gal.querySelector('.ba-gal__track');
      var slides = gal.querySelectorAll('.ba-gal__slide');
      var wrap = gal.closest('.ba-gal');
      var dots = wrap ? wrap.querySelectorAll('.ba-gal__dot') : [];
      var thumbs = wrap ? wrap.querySelectorAll('.ba-thumb') : [];
      if (!track || slides.length < 2) return;

      var last = -1;
      var snapTimer, raf;

      function current() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }

      function releaseSnap(ms) {
        track.style.scrollSnapType = 'none';
        clearTimeout(snapTimer);
        snapTimer = setTimeout(function () {
          track.style.scrollSnapType = '';
        }, ms);
      }

      function goTo(i) {
        var n = Math.max(0, Math.min(slides.length - 1, i));
        var left = n * track.clientWidth;
        if (reduced) {
          releaseSnap(60);
          track.scrollLeft = left;
          return;
        }
        releaseSnap(700);
        track.scrollTo({ left: left, behavior: 'smooth' });
      }

      function sync() {
        var n = current();
        if (n === last) return;
        last = n;
        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-current', i === n ? 'true' : 'false');
        }
        for (var j = 0; j < thumbs.length; j++) {
          thumbs[j].setAttribute('aria-current', j === n ? 'true' : 'false');
        }
      }

      /* ----- Desplazamiento automático ----- */
      var every = parseInt(gal.getAttribute('data-autoplay') || '0', 10);
      var paused = false;
      var visible = true;
      var resumeTimer;

      function hold() {
        paused = true;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, 6000);
      }

      gal.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') paused = true;
      });
      gal.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') paused = false;
      });
      track.addEventListener('touchstart', hold, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) { visible = entries[0].isIntersecting; },
          { rootMargin: '100px' }
        ).observe(gal);
      }

      var prev = gal.querySelector('[data-ba-gal-prev]');
      var next = gal.querySelector('[data-ba-gal-next]');

      if (prev) prev.addEventListener('click', function () {
        hold();
        var n = current();
        goTo(n <= 0 ? slides.length - 1 : n - 1);
      });

      if (next) next.addEventListener('click', function () {
        hold();
        var n = current();
        goTo(n >= slides.length - 1 ? 0 : n + 1);
      });

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { hold(); goTo(i); });
      });
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { hold(); goTo(i); });
      });

      track.addEventListener(
        'scroll',
        function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(sync);
        },
        { passive: true }
      );

      sync();

      if (every && !reduced) {
        setInterval(function () {
          if (paused || !visible || document.hidden) return;
          var n = current();
          goTo(n >= slides.length - 1 ? 0 : n + 1);
        }, every);
      }
    });

    /* ---------- Total en vivo al cambiar de oferta ---------- */
    scope.querySelectorAll('[data-ba-pdp]').forEach(function (pdp) {
      if (pdp.__baPdp) return;
      pdp.__baPdp = true;

      var radios = pdp.querySelectorAll('input[name="id"]');
      if (!radios.length) return;

      var totalEl = pdp.querySelector('[data-ba-total]');
      var qtyEl = pdp.querySelector('[data-ba-qty]');
      var wideEl = pdp.querySelector('[data-ba-cta-total]');

      function paint() {
        var checked = pdp.querySelector('input[name="id"]:checked') || radios[0];
        if (!checked) return;
        var total = checked.getAttribute('data-total') || '';
        var label = checked.getAttribute('data-label') || '';
        if (totalEl) totalEl.textContent = total;
        if (qtyEl) qtyEl.textContent = label;
        if (wideEl) wideEl.textContent = total;
        radios.forEach(function (r) {
          var card = r.closest('.ba-offer');
          if (card) card.classList.toggle('is-selected', r.checked);
        });
      }

      radios.forEach(function (r) { r.addEventListener('change', paint); });

      pdp.querySelectorAll('[data-ba-buy]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-ba-buy');
          var radio = pdp.querySelector('input[name="id"][value="' + id + '"]');
          if (radio && !radio.checked) {
            radio.checked = true;
            paint();
          }
        });
      });

      paint();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
